(function () {
  'use strict';
  if (window.drazzelProductBundles) return;
  window.drazzelProductBundles = true;

  var pages = new Map();
  var selection = 0;
  var currentUrl = window.location.href;

  function loadHomepageVideoReviews() {
    if (!document.querySelector('body.template-product')) return;
    var current = document.querySelector('#MainContent [data-video-reviews]');
    if (!current) return;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    fetch(root, { credentials: 'same-origin', cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load homepage reviews');
      return response.text();
    }).then(function (html) {
      var home = new DOMParser().parseFromString(html, 'text/html');
      var shared = home.querySelector('[data-video-reviews]');
      var target = document.querySelector('#MainContent [data-video-reviews]');
      if (!shared || !target) return;
      var replacement = shared.cloneNode(true);
      target.replaceWith(replacement);
      if (window.initVideoReviewSection) window.initVideoReviewSection(replacement);
    }).catch(function () {});
  }
  loadHomepageVideoReviews();

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-variant-button]');
    var selected = document.querySelector('[data-pdp-bundle-slot] .pdp-bundle-card[aria-current="true"]');
    var section = document.querySelector('[data-product-section]');
    if (!button || !selected || !section) return;
    var amount = Number(button.dataset.variantPrice);
    var compareAmount = Number(button.dataset.variantCompare);
    var onSale = compareAmount > amount;
    var currency = section.dataset.currency || 'INR';
    function format(cents) {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    }
    var price = selected.querySelector('.pdp-bundle-card__prices b');
    var compare = selected.querySelector('.pdp-bundle-card__prices s');
    var unit = selected.querySelector('.pdp-bundle-card__unit-price');
    if (price) price.textContent = format(amount);
    if (compare) { compare.hidden = !onSale; compare.textContent = format(compareAmount); }
    if (unit) unit.textContent = '(' + format(Math.round(amount / Number(selected.dataset.packCount || 1))) + ' / each)';
  });

  function getPage(url) {
    if (!pages.has(url)) {
      pages.set(url, fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Unable to load product');
        return response.text();
      }).then(function (html) {
        var page = new DOMParser().parseFromString(html, 'text/html');
        if (!page.querySelector('[data-product-section]')) throw new Error('Product content unavailable');
        return page;
      }).catch(function (error) { pages.delete(url); throw error; }));
    }
    return pages.get(url);
  }

  function copyPart(from, to, selector) {
    var source = from.querySelector(selector);
    var target = to.querySelector(selector);
    if (target && source) target.replaceWith(source.cloneNode(true));
    else if (target) target.remove();
  }

  function bindProduct(section) {
    section.querySelectorAll('[data-product-variant-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var amount = Number(button.dataset.variantPrice);
        var old = Number(button.dataset.variantCompare);
        var onSale = old > amount;
        var format = new Intl.NumberFormat('en-IN', { style: 'currency', currency: section.dataset.currency || 'INR' });
        section.querySelector('[data-product-variant-id]').value = button.dataset.variantId;
        section.querySelector('[data-product-price]').textContent = format.format(amount / 100);
        [section, document.querySelector('[data-product-sticky-bar]')].forEach(function (root) {
          if (!root) return;
          var compare = root.querySelector('[data-product-compare], [data-sticky-compare]');
          var discount = root.querySelector('[data-product-discount], [data-sticky-discount]');
          if (compare) { compare.hidden = !onSale; compare.textContent = format.format(old / 100); }
          if (discount) { discount.hidden = !onSale; discount.textContent = onSale ? '-' + Math.round((old - amount) * 100 / old) + '%' : ''; }
          var price = root.querySelector('[data-sticky-price]');
          var input = root.querySelector('[data-sticky-variant-id]');
          if (price) price.textContent = format.format(amount / 100);
          if (input) input.value = button.dataset.variantId;
        });
        section.querySelectorAll('[data-product-variant-button]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
      });
    });
    var gallery = section.querySelector('[data-product-gallery]');
    if (!gallery) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); thumb.click(); }
      });
    });
    var slides = gallery.querySelector('[data-gallery-mobile-slides]');
    var counter = gallery.querySelector('[data-gallery-counter]');
    if (slides && counter) slides.addEventListener('scroll', function () {
      counter.textContent = (Math.round(slides.scrollLeft / slides.clientWidth) + 1) + ' / ' + slides.children.length;
    }, { passive: true });
  }

  async function selectProduct(url, card, historyNavigation) {
    var section = document.querySelector('[data-product-section]');
    var group = document.querySelector('[data-pdp-bundle-slot] [data-pdp-bundle-group]');
    if (!section || !group || url === currentUrl) return;
    var request = ++selection;
    var status = group.querySelector('[data-bundle-status]');
    if (!status) { status = document.createElement('p'); status.className = 'pdp-bundles__status'; status.dataset.bundleStatus = ''; status.setAttribute('role', 'status'); group.appendChild(status); }
    group.querySelectorAll('.pdp-bundle-card').forEach(function (item) { item.classList.remove('is-loading'); });
    if (card) card.classList.add('is-loading');
    status.textContent = 'Loading pack…';
    section.setAttribute('aria-busy', 'true');
    document.querySelectorAll('.product-detail__actions, [data-product-sticky-bar] form').forEach(function (form) { form.inert = true; });
    // Block checkout until the new product ID and visible content agree.
    var buttons = Array.from(document.querySelectorAll('.product-detail__actions button[type="submit"], [data-product-sticky-bar] button'));
    var states = buttons.map(function (button) { return button.disabled; });
    if (!section.__bundleButtonStates) section.__bundleButtonStates = states;
    buttons.forEach(function (button) { button.disabled = true; });
    try {
      var page = await getPage(url);
      if (request !== selection) return;
      var next = page.querySelector('[data-product-section]');
      var nextForm = next.querySelector('.product-detail__actions');
      var form = section.querySelector('.product-detail__actions');
      var nextId = nextForm && nextForm.querySelector('[data-product-variant-id]');
      if (!form || !nextId) throw new Error('Product purchase data unavailable');
      copyPart(next, section, '.product-detail__mobile-summary');
      copyPart(next, section, '[data-product-gallery]');
      var info = section.querySelector('.product-detail__info');
      var nextInfo = next.querySelector('.product-detail__info');
      // Replace the summary as a unit, including optional short description.
      Array.from(info.children).forEach(function (node) {
        if (node.matches('h1, .product-detail__description, .product-detail__rating')) node.remove();
      });
      Array.from(nextInfo.children).filter(function (node) { return node.matches('h1, .product-detail__description, .product-detail__rating'); }).reverse().forEach(function (node) { info.prepend(node.cloneNode(true)); });
      copyPart(next, section, '.product-detail__price');
      var options = section.querySelector('.product-detail__options');
      if (options) options.remove();
      var nextOptions = next.querySelector('.product-detail__options');
      var bundleSlot = section.querySelector('[data-pdp-bundle-slot]');
      if (nextOptions) (bundleSlot || form).before(nextOptions.cloneNode(true));
      form.querySelector('[data-product-variant-id]').value = nextId.value;
      var available = !!nextForm.querySelector('.product-detail__add');
      var buy = form.querySelector('.product-detail__buy');
      var add = form.querySelector('.product-detail__add');
      if (buy) { buy.disabled = !available; buy.textContent = available ? 'Buy now' : 'Out of stock'; buy.setAttribute('aria-disabled', String(!available)); buy.classList.toggle('gokwik-sold-out', !available); }
      if (add) { add.disabled = !available; add.setAttribute('aria-label', 'Add ' + nextInfo.querySelector('h1').textContent + ' to cart'); }
      var sticky = document.querySelector('[data-product-sticky-bar]');
      var nextSticky = page.querySelector('[data-product-sticky-bar]');
      if (sticky && nextSticky) {
        copyPart(nextSticky, sticky, '.product-sticky-bar__product');
        sticky.querySelector('[data-sticky-variant-id]').value = nextId.value;
        var stickyBuy = sticky.querySelector('button');
        stickyBuy.disabled = !available;
        stickyBuy.classList.toggle('gokwik-sold-out', !available);
      }
      copyPart(page, document, '.product-accordions');
      copyPart(page, document, '[data-product-faqs]');
      copyPart(page, document, '[data-product-content-image]');
      section.dataset.currency = next.dataset.currency;
      bindProduct(section);
      group.querySelectorAll('.pdp-bundle-card').forEach(function (item) {
        var active = item.href === url;
        item.classList.toggle('is-selected', active);
        if (active) item.setAttribute('aria-current', 'true'); else item.removeAttribute('aria-current');
      });
      document.title = page.title;
      var canonical = document.querySelector('link[rel="canonical"]');
      var nextCanonical = page.querySelector('link[rel="canonical"]');
      if (canonical && nextCanonical) canonical.href = nextCanonical.href;
      currentUrl = url;
      if (!historyNavigation) window.history.pushState({ bundleProduct: true }, '', url);
      status.textContent = '';
      delete section.__bundleButtonStates;
      document.dispatchEvent(new CustomEvent('drazzel:product:changed', { detail: { url: url, variantId: nextId.value } }));
    } catch (error) {
      if (request !== selection) return;
      status.textContent = 'Unable to load this pack. Please try again.';
      var original = section.__bundleButtonStates || states;
      buttons.forEach(function (button, index) { button.disabled = original[index]; });
      delete section.__bundleButtonStates;
    } finally {
      if (request === selection) {
        section.removeAttribute('aria-busy');
        document.querySelectorAll('.product-detail__actions, [data-product-sticky-bar] form').forEach(function (form) { form.inert = false; });
        group.querySelectorAll('.pdp-bundle-card').forEach(function (item) { item.classList.remove('is-loading'); });
      }
    }
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('.pdp-bundle-card');
    if (!card || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || card.origin !== window.location.origin) return;
    event.preventDefault();
    if (!pages.has(currentUrl)) pages.set(currentUrl, Promise.resolve(document.cloneNode(true)));
    selectProduct(card.href, card, false);
  });
  ['pointerover', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var card = event.target.closest('.pdp-bundle-card');
      if (card && card.origin === window.location.origin) getPage(card.href).catch(function () {});
    }, { passive: true });
  });
  window.addEventListener('popstate', function () {
    if (window.location.href !== currentUrl) selectProduct(window.location.href, null, true);
  });

  function mountBundles() {
    var slot = document.querySelector('[data-pdp-bundle-slot]');
    var designMode = window.Shopify && window.Shopify.designMode;
    if (slot) slot.replaceChildren();

    document.querySelectorAll('[data-pdp-bundle-source]').forEach(function (source) {
      // Shopify owns its section wrappers. Keep them in their original sibling positions.
      source.hidden = !designMode;
      var template = source.querySelector('[data-pdp-bundle-template]');
      if (!slot || slot.children.length || !template || source.dataset.bundleProductId !== slot.dataset.productId) return;
      var group = template.content.querySelector('[data-pdp-bundle-group]');
      if (!group) return;
      var cards = group.cloneNode(true);
      cards.dataset.bundleSectionId = source.dataset.bundleSectionId;
      // The display copy belongs to Main product; editor controls belong to Bundle offers.
      cards.removeAttribute('data-shopify-editor-block');
      cards.querySelectorAll('[data-shopify-editor-block]').forEach(function (node) {
        node.removeAttribute('data-shopify-editor-block');
      });
      slot.appendChild(cards);
    });
  }

  function scrollToBundle(event) {
    var group = document.querySelector('[data-pdp-bundle-slot] [data-pdp-bundle-group]');
    if (!group || !event.detail) return;
    if (event.detail.sectionId === group.dataset.bundleSectionId || event.detail.blockId === group.dataset.bundleBlockId) {
      group.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var slot = document.querySelector('[data-pdp-bundle-slot]');
    var group = slot && slot.querySelector('[data-pdp-bundle-group]');
    if (group && event.detail && event.detail.sectionId === group.dataset.bundleSectionId) slot.replaceChildren();
  });
  document.addEventListener('shopify:section:load', mountBundles);
  document.addEventListener('shopify:section:reorder', mountBundles);
  document.addEventListener('shopify:section:select', scrollToBundle);
  document.addEventListener('shopify:block:select', scrollToBundle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountBundles);
  else mountBundles();
})();
